import { getLocale } from "../runtime";

const sv_atcountry = /** @type {(inputs?: {}) => string} */ (inputs) => {
	return `Österrike`
};

const atcountry = /** @type {(inputs?: {}, options?: {locale?: string}) => string} */ (inputs = {}, options = {}) => {
	const locale = options.locale ?? getLocale();
	if (locale === "sv") return sv_atcountry(inputs)
	return "atCountry";
};

export { atcountry as "atCountry" };